import React from 'react';
import { Link } from 'react-router-dom';
import FirmwareUpload from '../components/FirmwareUpload';
import '../App.css';

function Curved() {
  return (
    <div className="page-shell">
      <h3>曲面屏</h3>
      <p>&nbsp;</p>
      <p className="page-lead">科技美学与极致体验的完美融合。</p>
      <p>3.7 英寸曲面 E-Ink 触摸屏，Organic Thin Film Transistor（OTFT），科技美学与极致安全完美融合。</p>
      <p>&nbsp;</p>
      <p>OTA 升级，请移至公布的新平台。</p>
      {/*
      <p>OTA 远程升级固件上传：</p>
      <FirmwareUpload category="curved" label="上传曲面屏固件" />
      */}      
      <p>&nbsp;</p>
      <div className="page-actions">
        <Link to="/gallery/curved" className="link-card" title="设备列表">曲面屏设备列表</Link>
      </div>
      <p>&nbsp;</p>
    </div>
  );
}
export default Curved;
